import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TimelineNavigation = ({ 
  experiences, 
  activeFilter, 
  onFilterChange, 
  viewMode, 
  onViewModeChange,
  onScrollToExperience 
}) => {
  const filters = [
    { id: 'all', label: 'All Experience', icon: 'Briefcase' },
    { id: 'fulltime', label: 'Full-time', icon: 'Building' },
    { id: 'freelance', label: 'Freelance', icon: 'Users' },
    { id: 'internship', label: 'Internships', icon: 'GraduationCap' }
  ];

  const viewModes = [
    { id: 'timeline', label: 'Timeline View', icon: 'GitBranch' },
    { id: 'cards', label: 'Card View', icon: 'Grid3X3' }
  ];

  return (
    <div className="bg-white rounded-xl shadow-premium border border-border p-4 sm:p-6 mb-6 sm:mb-8">
      {/* Filter Tabs */}
      <div className="flex flex-wrap gap-2 mb-4 sm:mb-6">
        {filters.map((filter) => (
          <Button
            key={filter.id}
            variant={activeFilter === filter.id ? 'default' : 'outline'}
            size="sm"
            iconName={filter.icon}
            iconPosition="left"
            onClick={() => onFilterChange(filter.id)}
            className="flex-shrink-0 text-xs sm:text-sm"
          >
            <span className="hidden xs:inline">{filter.label}</span>
            <span className="xs:hidden">{filter.label.split(' ')[0]}</span>
          </Button>
        ))}
      </div>

      {/* View Mode Toggle */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center space-x-2">
          <Icon name="Eye" size={16} className="text-text-secondary flex-shrink-0" />
          <span className="text-xs sm:text-sm font-medium text-text-secondary whitespace-nowrap">View Mode:</span>
          <div className="flex bg-surface rounded-lg p-1">
            {viewModes.map((mode) => (
              <button
                key={mode.id}
                onClick={() => onViewModeChange(mode.id)}
                className={`flex items-center space-x-2 px-3 py-1.5 rounded text-sm font-medium transition-premium ${
                  viewMode === mode.id
                    ? 'bg-white text-primary shadow-sm'
                    : 'text-text-secondary hover:text-text-primary'
                }`}
              >
                <Icon name={mode.icon} size={14} />
                <span className="hidden sm:inline">{mode.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Quick Navigation */}
        <div className="hidden lg:flex items-center space-x-2">
          <span className="text-sm text-text-secondary">Jump to:</span>
          <div className="flex space-x-1">
            {experiences.slice(0, 4).map((exp, index) => (
              <button
                key={exp.id}
                onClick={() => onScrollToExperience(exp.id)}
                className="w-8 h-8 rounded-lg bg-surface hover:bg-primary/10 text-text-secondary hover:text-primary transition-premium flex items-center justify-center text-xs font-medium"
                title={exp.company}
              >
                {exp.company.charAt(0)}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Experience Count */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex flex-col xs:flex-row xs:items-center xs:justify-between gap-2 text-xs sm:text-sm text-text-secondary">
          <span>
            Showing {experiences.length} experience{experiences.length !== 1 ? 's' : ''}
          </span>
          <span className="flex items-center">
            <Icon name="Calendar" size={12} className="mr-1 flex-shrink-0" />
            <span className="whitespace-nowrap">4+ Years of Professional Growth</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default TimelineNavigation;